<ng-container *ngIf="getDriverStatus(); else plainTime">
  <div class="driver-profile__log d-inline-flex align-items-center gap-2"
    [ngClass]="getStatusClass(getDriverStatus()!)">
    <span class="driver-profile__log-icon">
      <svg *ngIf="getDriverStatus() === 'warning'" width="14" height="14" viewBox="0 0 14 14" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.74861 0.333008C3.08995 0.333008 0.113281 3.32367 0.113281 6.99967C0.113281 10.6757 3.10395 13.6663 6.77995 13.6663C10.4559 13.6663 13.4466 10.6757 13.4466 6.99967C13.4466 3.32367 10.4419 0.333008 6.74861 0.333008ZM7.44661 10.333H6.11328V8.99967H7.44661V10.333ZM7.44661 7.66634H6.11328V3.66634H7.44661V7.66634Z"
          fill="#FF7F00" />
      </svg>
      <svg *ngIf="getDriverStatus() === 'success'" width="14" height="14" viewBox="0 0 14 14" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.77995 0.333008C3.10395 0.333008 0.113281 3.32367 0.113281 6.99967C0.113281 10.6757 3.10395 13.6663 6.77995 13.6663C10.4559 13.6663 13.4466 10.6757 13.4466 6.99967C13.4466 3.32367 10.4559 0.333008 6.77995 0.333008ZM5.44728 9.94168L2.97195 7.47167L3.91328 6.52767L5.44595 8.05767L8.97528 4.52834L9.91795 5.47101L5.44728 9.94168Z"
          fill="#50AD41" />
      </svg>
      <svg *ngIf="getDriverStatus() === 'caution'" width="14" height="14" viewBox="0 0 14 14" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.77995 0.333008C3.10395 0.333008 0.113281 3.32367 0.113281 6.99967C0.113281 10.6757 3.10395 13.6663 6.77995 13.6663C10.4559 13.6663 13.4466 10.6757 13.4466 6.99967C13.4466 3.32367 10.4559 0.333008 6.77995 0.333008ZM8.97528 10.1377L6.11328 7.27567V2.99967H7.44661V6.72367L9.91795 9.19501L8.97528 10.1377Z"
          fill="#F4BC2B" />
      </svg>
      <svg *ngIf="getDriverStatus() === 'default'" width="15" height="14" viewBox="0 0 15 14" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.39323 0.333008C3.71723 0.333008 0.726562 3.32367 0.726562 6.99967C0.726562 10.6757 3.71723 13.6663 7.39323 13.6663C11.0692 13.6663 14.0599 10.6757 14.0599 6.99967C14.0599 3.32367 11.0692 0.333008 7.39323 0.333008Z"
          fill="#9FA1A4" />
      </svg>
    </span>
    <span class="driver-profile__log-time">{{ getDisplayTime() }}</span>
  </div>
</ng-container>

<ng-template #plainTime>
  <span class="driver-profile__log-time">{{ getDisplayTime() }}</span>
</ng-template>